// const Intro = () => import(
//   /* webpackChunkName: "intro" */
//   'intro.js');

const Intro = () => import(
  /* webpackChunkName: "intro" */
  './intro.js');

export default Intro;
